// Generated by CoffeeScript 1.12.7
(function() {
  var VASTAdExtension;

  VASTAdExtension = (function() {
    function VASTAdExtension() {
      this.attributes = {};
      this.children = [];
    }

    return VASTAdExtension;

  })();

  module.exports = VASTAdExtension;

}).call(this);



//////////////////
// WEBPACK FOOTER
// ../~/vast-client/dist/extension.js
// module id = 64
// module chunks = 0